// extracted by mini-css-extract-plugin
module.exports = {"red":"map-module--red--3gl3V","green":"map-module--green--18iak"};